import { render, staticRenderFns } from "./DynamicFormView.vue?vue&type=template&id=b510f4be&scoped=true&"
import script from "./DynamicFormView.vue?vue&type=script&lang=js&"
export * from "./DynamicFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510f4be",
  null
  
)

export default component.exports